<template>
  <div v-if="$currentApp" class="actions-value-wrapper">
    <UiSwitch
      id="blockAccount"
      ref="toggleSwitcher"
      :title="actionsHelper.buttonText"
      :is-checked-initial="!isDisabledApplication"
      @input="accountActionClicked"
    />
  </div>
</template>

<script>
import UiSwitch from '@/components/UiSwitch.vue';
import currentApplicationMixin from '../mixins/currentApplicationMixin'

import { disableAccount, enableAccount } from './AccountActionsMethods'

export default {
  components: {
    UiSwitch
  },
  mixins: [currentApplicationMixin],
  computed: {
    isDisabledApplication() {
      return this.$currentApp && this.$currentApp.disabled === 1;
    },
    actionsHelper() {
      return this.isDisabledApplication
        ? {
          action: 'enableAccount',
          status: 'Разблокировать',
          buttonText: 'Разблокировать аккаунт',
          color: '#32d74b',
        }
        : {
          action: 'disableAccount',
          buttonText: 'Заблокировать аккаунт',
          status: 'Заблокировать',
          color: '#ff6464',
        }
    },
  },
  methods: {
    async accountActionClicked(action) {
      /** {object} `actionsHashes` Object contains all actions */
      const actionsHashes = { disableAccount, enableAccount }

      const result = await actionsHashes[this.actionsHelper.action].call(this);

      result.isConfirmed
        ? this.setAccountStatus(Number(!this.isDisabledApplication))
        : this.$refs.toggleSwitcher.resetSwitcher();
    },

    /**
     * Update google cert status without backend request.
     */
    setAccountStatus(value) {
      this.$store.commit('application/SET_CURRENT_APPLICATION', {
        ...this.$currentApp,
        disabled: value,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.actions-value-wrapper {
  @include createFlex(flexbox, nowrap, row, flex-end, stretch, center);

  .action-icon {
    display: inline-block;
    margin: 0 0 0 rem(8px);
    cursor: pointer;
  }
}

.actions-value-text {
  margin-right: 12px;
}
</style>
